// import { ReactQueryDevtools } from "react-query/devtools";
import { Fragment, useEffect } from "react";
import axios from "axios";
import io from "socket.io-client";
import "react-toastify/dist/ReactToastify.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import { toast } from "react-toastify";
import PapierPriseEnCharge from "./Components/PriseEnCharge/PapierPriseEnCharge"
import AnnualRevenu from "./Components/charts/AnnualRevenu";
import ProtectedRoute from "./Components/protectedRoute/ProtectedRoute";
import Login from "./Components/Authentication/Login";
import PriseEnCharge from "./Components/PriseEnCharge/PriseEnCharge";
import Dashboard from "./Components//Authentication/Dashboard";
import CreatePatientelle from "./Components/Patientelle/CreatePatientelle/CreatePatientelle";
import UpdatePatientelle from "./Components/Patientelle/UpdatePatientelle/UpdatePatientelle";
import DeletePatientelle from "./Components/Patientelle/DeletePatientelle/DeletePatientelle";
import MutuelleAct from "./Components/ActPatient/Steps/MutuelleAct";
import AddToWaitingList from "./Components/ActPatient/Steps/AddToWaitingList";
import ActPatientGrid from "./Components/ActPatient/ActPatientGrid";
import ActPatientGridHistoric from "./Components/ActPatientHistoric/ActPatientGrid";
import PaymentAct from "./Components/ActPatient/Steps/PaymentAct";
import PaymentActHistoric from "./Components/ActPatientHistoric/Steps/PaymentAct";
import PaymentActAllActs from "./Components/ActPatient/Steps/PaymentActAllActs";
import PaymentActAllActsHistoric from "./Components/ActPatientHistoric/Steps/PaymentActAllActs";
import ActPatientGridDone from "./Components/ActPatient/ActPatientGridDone";
import ActPatientGridDoneHistoric from "./Components/ActPatientHistoric/ActPatientGridDone";
import ActPatientGridDidntComeHistoric from "./Components/ActPatientHistoric/ActPatientGridDidntCome";
import ActPatientGridDidntCome from "./Components/ActPatient/ActPatientGridDidntCome";
import Consultation from "./Components/Consultation/Consultation";
import Stock from "./Components/Stock/Stock"
import Fournisseurs from "./Components/Stock/Fournisseurs"
import { useSelector, useDispatch } from "react-redux";
import {
  check_Authenticated,
  selectisAuthenticated,
} from "./features/auth/authSlice";
import "./App.css";
import Day from "./Components/charts/Day";
import Years from "./Components/charts/Years";
import Months from "./Components/charts/Months";
import Weeks from "./Components/charts/Weeks";
import ByProdducts from "./Components/charts/ByProdducts";
import CreatePriseEnChagre from "./Components/PriseEnCharge/CreatePriseEnChagre";
import PatientelleGridPriseEnCharge from "./Components/PriseEnCharge/patientellePrise/PatientelleGridPriseEnCharge";
import UpdatePriseEnCarge from "./Components/PriseEnCharge/UpdatePriseEnCarge";
import DeletePriseEnCharge from "./Components/PriseEnCharge/DeletePriseEnCharge";
import BlocMain from "./Components/Bloc/Bloc_Main";
import CreateBloc from "./Components/Bloc/CreateBloc";
import UpdateBloc from "./Components/Bloc/UpdateBloc";
import DeleteOneBloc from "./Components/Bloc/DeleteOneBloc";
import PapierBloc from "./Components/Bloc/PapierBloc";
import PatientelleGridBloc from "./Components/Bloc/patientellePrise/PatientelleGridBloc";
toast.configure();

export const server = process.env.REACT_APP_SERVER;
export const socket = io.connect(process.env.REACT_APP_SERVER, {
  withCredentials: true,
});

function App() {
  const Auth = useSelector(selectisAuthenticated);
  const dispatch = useDispatch();

  const checkAuthenticated = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_SERVER}authentication/verify`,
        {
          method: "GET",
          headers: { jwtoken: sessionStorage.token },
        }
      );

      const parseRes = await res.json();

      parseRes === true && dispatch(check_Authenticated(parseRes));
    } catch (err) {
      console.error(err.message);
    }
  };

  // Add a 401 response interceptor
  axios.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (401 === error.response.status) {
        dispatch(check_Authenticated(false));
      } else {
        return Promise.reject(error);
      }
    }
  );
  useEffect(() => {
    checkAuthenticated();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      {/* <ReactQueryDevtools /> */}
      <Router>
        <Routes>
          <Route
            path="/login"
            element={!Auth.isAuthenticated ? <Login /> : <Navigate to="/" />}
          />
          {/* <Route
            path="/register"
            element={!Auth.isAuthenticated ? <Register /> : <Navigate to="/" />}
          /> */}
          {/* <Route
              exact
              path="/"
              render={(props) =>
                Auth.isAuthenticated ? (
                  <Dashboard {...props} />
                ) : (
                  <Navigate to="/login" />
                )
                <Dashboard />
              }
            /> */}
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          {/* <ProtectedRoute exact path="/PatientelleGrid" element={Dashboard} /> */}
          <Route
            path="/CreatePatientelle"
            element={
              <ProtectedRoute>
                <CreatePatientelle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/UpdatePatientelle"
            element={
              <ProtectedRoute>
                <UpdatePatientelle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/DeletePatientelle"
            element={
              <ProtectedRoute>
                <DeletePatientelle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/MutuelleAct"
            element={
              <ProtectedRoute>
                <MutuelleAct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AddToWaitingList"
            element={
              <ProtectedRoute>
                <AddToWaitingList />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ActPatientGrid"
            element={
              <ProtectedRoute>
                <ActPatientGrid />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PaymentAct"
            element={
              <ProtectedRoute>
                <PaymentAct />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PaymentActAllActs"
            element={
              <ProtectedRoute>
                <PaymentActAllActs />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ActPatientGridDone"
            element={
              <ProtectedRoute>
                <ActPatientGridDone />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ActPatientGridDidntCome"
            element={
              <ProtectedRoute>
                <ActPatientGridDidntCome />
              </ProtectedRoute>
            }
          />
          {/* --------------------------------------------- */}
          <Route
            path="/ActPatientGridHistoric"
            element={
              <ProtectedRoute>
                <ActPatientGridHistoric />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PaymentActHistoric"
            element={
              <ProtectedRoute>
                <PaymentActHistoric />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PaymentActAllActsHistoric"
            element={
              <ProtectedRoute>
                <PaymentActAllActsHistoric />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ActPatientGridDoneHistoric"
            element={
              <ProtectedRoute>
                <ActPatientGridDoneHistoric />
              </ProtectedRoute>
            }
          />
          <Route
            path="/ActPatientGridDidntComeHistoric"
            element={
              <ProtectedRoute>
                <ActPatientGridDidntComeHistoric />
              </ProtectedRoute>
            }
          />
          {/* ---------------------------------------------- */}
          <Route
            path="/Consultation"
            element={
              <ProtectedRoute>
                <Consultation />
              </ProtectedRoute>
            }
          />
          <Route
            path="/PriseEnCharge"
            element={
              <ProtectedRoute>
                <PriseEnCharge />
              </ProtectedRoute>
            }
          />
          <Route
            path="/AnnualRevenu"
            element={
              <ProtectedRoute>
                <AnnualRevenu />
              </ProtectedRoute>
            }
          >
            <Route
              path="Years"
              element={
                <ProtectedRoute>
                  <Years />
                </ProtectedRoute>
              }
            />
            <Route
              path="Months"
              element={
                <ProtectedRoute>
                  <Months />
                </ProtectedRoute>
              }
            />
            <Route
              path="Weeks"
              element={
                <ProtectedRoute>
                  <Weeks />
                </ProtectedRoute>
              }
            />
            <Route
              path="Day"
              element={
                <ProtectedRoute>
                  <Day />
                </ProtectedRoute>
              }
            />
            <Route
              path="ByProducts"
              element={
                <ProtectedRoute>
                  <ByProdducts />
                </ProtectedRoute>
              }
            />
          </Route>
          <Route
            path="CreatePriseEnChagre"
            element={
              <ProtectedRoute>
                <CreatePriseEnChagre />
              </ProtectedRoute>
            }
          />
          <Route
            path="PatientelleGridPriseEnCharge"
            element={
              <ProtectedRoute>
                <PatientelleGridPriseEnCharge />
              </ProtectedRoute>
            }
          />
          <Route
            path="UpdatePriseEnCarge"
            element={
              <ProtectedRoute>
                <UpdatePriseEnCarge />
              </ProtectedRoute>
            }
          />
          <Route
            path="DeletePriseEnCharge"
            element={
              <ProtectedRoute>
                <DeletePriseEnCharge />
              </ProtectedRoute>
            }
          />
          <Route
            path="bloc_Main"
            element={
              <ProtectedRoute>
                <BlocMain />
              </ProtectedRoute>
            }
          />
          <Route
            path="PatientelleGridBloc"
            element={
              <ProtectedRoute>
                <PatientelleGridBloc />
              </ProtectedRoute>
            }
          />
          <Route
            path="CreateBloc"
            element={
              <ProtectedRoute>
                <CreateBloc />
              </ProtectedRoute>
            }
          />
          <Route
            path="UpdateBloc"
            element={
              <ProtectedRoute>
                <UpdateBloc />
              </ProtectedRoute>
            }
          />
          <Route
            path="DeleteOneBloc"
            element={
              <ProtectedRoute>
                <DeleteOneBloc />
              </ProtectedRoute>
            }
          />
          <Route
            path="PapierBloc"
            element={
              <ProtectedRoute>
                <PapierBloc />
              </ProtectedRoute>
            }
          />
          <Route
            path="PapierPriseEnCharge"
            element={
              <ProtectedRoute>
                <PapierPriseEnCharge />
              </ProtectedRoute>
            }
          />
          <Route
            path="Stock"
            element={
              <ProtectedRoute>
                <Stock />
              </ProtectedRoute>
            }
          />
          <Route
            path="Fournisseurs"
            element={
              <ProtectedRoute>
                <Fournisseurs />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </Fragment>
  );
}

export default App;
